<template>
    <div>
        <v-autocomplete
            :label="label"
            :items="list"
            v-model="input"
            item-value="id"
            item-text="horario"
            :loading="loadingComputed"          
            :disabled="loadingComputed || disabledComputed"
            :auto-select-first="true"
            :filled="filled"
            @change="changed($event)"
            clearable
            hide-details
            :multiple="multiple"
            :dense="dense"
            style="min-width: 250px"
            />
    </div>
</template>
<script>
import SelectorService from '@services/front/SelectorService';

export default {
    props: {
        value: {
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        }, 
        label: { 
            type: String, 
            default: 'Seleccione un Juego Sorteo' 
        },
        params: {
            type: Object,
        },
        filled: {
            type: Boolean,
            default: true,
        },
        juegoSorteo: {
            default: () => {
                return null;
            },
        },
        autoselect: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        }
    },
    data: function () {
        return {
            fetching: false,
            cannotSelect: false,
            list: [],
            input: this.multiple ? [] : null,
            debounceFetch: this.$lodash.debounce((reset = true) => {
                this.fetch(reset);
            }, 500),
        }
    },
    computed: {
        disabledComputed: function () {
            return this.cannotSelect || this.disabled;
        },
        loadingComputed: function () {
            return !!(this.fetching || this.loading);
        }
    },
    mounted: function () {
        this.debounceFetch(false);
    },
    methods: {
        changed: function (value) {
            this.$emit('input', value);
            this.$emit('change', value);
            if (this.multiple) {
                this.$emit('update:juegoSorteo', this.list.filter(juegoSorteo => value.some(juego_sorteo_id => juego_sorteo_id == juegoSorteo.id)));
            } else {
                this.$emit('update:juegoSorteo', this.list.find(juegoSorteo => juegoSorteo.id == value));
            }
        },
        fetch: function (reset = true) {
            this.list = [];

            if (reset) this.input = this.multiple ? [] : null;
            else this.input = this.multiple ? [this.value] : this.value;

            if (!this.params.juego_id) {
                this.cannotSelect = true;
                return;
            } else this.cannotSelect = false;

            this.fetching = true;

            SelectorService
                .getJuegoSorteo(this.params)
                .then(({ juegoSorteoList = [] }) => {
                    this.list = juegoSorteoList;

                    if (juegoSorteoList.length == 1) {
                        this.input = this.multiple ? [juegoSorteoList[0].id] : juegoSorteoList[0].id;
                        return;
                    }

                    if (!this.autoselect) return;
                    if ((this.multiple && this.input.length) || this.input) return;

                    const hora = this.$luxon.now();
                    
                    const firstJuegoSorteo = juegoSorteoList[0];
                    const lastJuegoSorteo = juegoSorteoList[juegoSorteoList.length - 1];

                    if (this.multiple) this.input = [juegoSorteoList.find((juegoSorteo) => hora <= this.$luxon.fromFormat(juegoSorteo.horario, 'HH:mm:ss'))?.id];
                    else this.input = juegoSorteoList.find((juegoSorteo) => hora <= this.$luxon.fromFormat(juegoSorteo.horario, 'HH:mm:ss'))?.id;
                    
                    if (!this.$lodash.isEmpty(this.input)) return;

                    if (this.$lodash.isEmpty(this.input) && hora <= this.$luxon.fromFormat(firstJuegoSorteo.horario, 'HH:mm:ss')) {
                        if (this.multiple) this.input = [firstJuegoSorteo.id];
                        else this.input = firstJuegoSorteo.id;
                        return;
                    }

                    if (this.$lodash.isEmpty(this.input) && hora >= this.$luxon.fromFormat(lastJuegoSorteo.horario, 'HH:mm:ss')) {
                        if (this.multiple) this.input = [lastJuegoSorteo.id];
                        else this.input = lastJuegoSorteo.id;
                        return;
                    }
                })
                .finally(() => {
                    this.fetching = false;
                });
        },
    },
    watch: {
        value: function (value) {
            if (this.$lodash.isEqual(this.input, value)) return;
            this.input = this.multiple ? [value] : value;
        },
        input: function (value) {
            this.changed(value);
        },
        params: {
            handler: function (value, oldParams) {
                if (this.$lodash.isEqual(value, oldParams)) return;
                this.debounceFetch();
            },
            deep: true,
        }
    }
}
</script>